var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "settlement-amount col-md-12 flex mt-4" },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-2 col-sm-4 mb-3" }, [
          _vm.$_can("claims.settlement-amounts.store")
            ? _c("div", { staticClass: "select-wrap" }, [
                _c("label", [_vm._v("Office")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.officeSettlementAmount.amount,
                      expression: "officeSettlementAmount.amount"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.officeSettlementAmount.amount },
                  on: {
                    change: function($event) {
                      _vm.createOrUpdateAmount(_vm.officeSettlementAmount)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.officeSettlementAmount,
                        "amount",
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            : _c("span", [
                _c("span", [_vm._v("Office")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.officeSettlementAmount.amount) +
                      "\n        "
                  )
                ])
              ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "col-lg-10 col-sm-8 mb-3 settlement-approve flex align-items-center",
            class: _vm.settlementStatusDeclineClass(3)
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "settlement-approve-row col-md-12 flex align-items-center",
                class: _vm.settlementStatusClass(1)
              },
              [
                !_vm.settlementTypeOffice
                  ? _c("span", [_vm._v("Amount wasn't entered.")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.settlementNotSent(3)
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "flex w-full justify-content-between align-items-center"
                      },
                      [
                        _c("div", [_vm._v("Request not sent.")]),
                        _vm._v(" "),
                        _vm.$_can("claims.settlement-amounts.store")
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-outline-secondary btn-sm",
                                class: _vm.loadingButtonOffice ? "running" : "",
                                attrs: { disabled: _vm.disabledButtonOffice },
                                on: { click: _vm.sendOfficeAuth }
                              },
                              [
                                _vm._v(
                                  "\n            Request office auth\n            "
                                ),
                                _vm.loadingButtonOffice
                                  ? _c("div", {
                                      staticClass: "ld ld-ball ld-flip"
                                    })
                                  : _vm._e()
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.settlementSent(3)
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "flex w-full justify-content-between align-items-center"
                      },
                      [
                        _c("span", [
                          _vm._v("Requested for "),
                          _c("span", { staticClass: "sett-amount" }, [
                            _vm._v("$" + _vm._s(_vm.settlementAmount(3)))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm.$_can("claims.settlement-amounts.office.approve")
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn-decline btn-sm",
                                  on: { click: _vm.toggleOfficeDeclineModal }
                                },
                                [_vm._v("Decline")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$_can("claims.settlement-amounts.office.approve")
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn-approve btn-sm",
                                  on: {
                                    click: function($event) {
                                      _vm.updateSettlementAmount(
                                        _vm.officeSettlementAmount,
                                        3
                                      )
                                    }
                                  }
                                },
                                [_vm._v("Approve")]
                              )
                            : _vm._e()
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.settlementApproved(3)
                  ? _c("span", [
                      _c("i", {
                        staticClass: "fa fa-check-circle approved-icon"
                      }),
                      _vm._v(
                        "\n          Office price has been approved -\n          "
                      ),
                      _c("span", { staticClass: "sett-amount" }, [
                        _vm._v("$" + _vm._s(_vm.settlementAmount(3)))
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.settlementDeclined(3)
                  ? _c("span", { staticClass: "w-full pa-8px" }, [
                      _c(
                        "span",
                        {
                          staticClass:
                            "flex w-full justify-content-between align-items-center"
                        },
                        [
                          _c("span", [
                            _c("i", {
                              staticClass: "fa fa-times-circle denied-icon"
                            }),
                            _vm._v(
                              "\n              Office price denied -\n              "
                            ),
                            _c("span", { staticClass: "sett-amount" }, [
                              _vm._v("$" + _vm._s(_vm.settlementAmount(3)))
                            ])
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm.settlementNote(3)
                        ? _c("hr", { staticClass: "line-decline" })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _vm.settlementNote(3)
                            ? _c("read-more", {
                                staticClass: "show-more",
                                attrs: {
                                  "more-str": "Show more",
                                  text: _vm.settlementNote(3),
                                  "less-str": "Show less",
                                  "max-chars": 200
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-2 col-sm-4 mb-3" }, [
          _vm.$_can("claims.settlement-amounts.store")
            ? _c("div", { staticClass: "select-wrap" }, [
                _c("label", [_vm._v("Subco")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.subcoSettlementAmount.amount,
                      expression: "subcoSettlementAmount.amount"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.subcoSettlementAmount.amount },
                  on: {
                    change: function($event) {
                      _vm.createOrUpdateAmount(_vm.subcoSettlementAmount)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.subcoSettlementAmount,
                        "amount",
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            : _c("span", [
                _c("span", [_vm._v("Subco")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.subcoSettlementAmount.amount) +
                      "\n        "
                  )
                ])
              ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "col-lg-10 col-sm-8 mb-3 settlement-approve flex align-items-center",
            class: _vm.settlementStatusDeclineClass(2)
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "settlement-approve-row col-md-12 flex align-items-center",
                class: _vm.settlementStatusClass(2)
              },
              [
                !_vm.settlementTypeSubco
                  ? _c("span", [_vm._v("Amount wasn't entered.")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.settlementNotSent(2)
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "flex w-full justify-content-between align-items-center"
                      },
                      [
                        _c("div", [_vm._v("Request not sent.")]),
                        _vm._v(" "),
                        _vm.$_can("claims.settlement-amounts.store")
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-outline-secondary btn-sm",
                                class: _vm.loadingButtonSubco ? "running" : "",
                                attrs: { disabled: _vm.disabledButtonSubco },
                                on: { click: _vm.sendSubcoAuth }
                              },
                              [
                                _vm._v(
                                  "\n            Request subco auth\n            "
                                ),
                                _vm.loadingButtonSubco
                                  ? _c("div", {
                                      staticClass: "ld ld-ball ld-flip"
                                    })
                                  : _vm._e()
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.settlementSent(2)
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "flex w-full justify-content-between align-items-center"
                      },
                      [
                        _c("span", [
                          _vm._v("Requested for "),
                          _c("span", { staticClass: "sett-amount" }, [
                            _vm._v("$" + _vm._s(_vm.settlementAmount(2)))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm.$_can("claims.settlement-amounts.subco.approve")
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn-decline btn-sm",
                                  on: { click: _vm.toggleSubcoDeclineModal }
                                },
                                [_vm._v("Decline")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$_can("claims.settlement-amounts.subco.approve")
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn-approve btn-sm",
                                  on: {
                                    click: function($event) {
                                      _vm.updateSettlementAmount(
                                        _vm.subcoSettlementAmount,
                                        3
                                      )
                                    }
                                  }
                                },
                                [_vm._v("Approve")]
                              )
                            : _vm._e()
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.settlementApproved(2)
                  ? _c("span", [
                      _c("i", {
                        staticClass: "fa fa-check-circle approved-icon"
                      }),
                      _vm._v(
                        "\n          Subco price has been approved -\n          "
                      ),
                      _c("span", { staticClass: "sett-amount" }, [
                        _vm._v("$" + _vm._s(_vm.settlementAmount(2)))
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.settlementDeclined(2)
                  ? _c("span", { staticClass: "w-full pa-8px" }, [
                      _c(
                        "span",
                        {
                          staticClass:
                            "flex w-full justify-content-between align-items-center"
                        },
                        [
                          _c("span", [
                            _c("i", {
                              staticClass: "fa fa-times-circle denied-icon"
                            }),
                            _vm._v(
                              "\n              Subco price denied -\n              "
                            ),
                            _c("span", { staticClass: "sett-amount" }, [
                              _vm._v("$" + _vm._s(_vm.settlementAmount(2)))
                            ])
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm.settlementNote(2)
                        ? _c("hr", { staticClass: "line-decline" })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _vm.settlementNote(2)
                            ? _c("read-more", {
                                staticClass: "show-more",
                                attrs: {
                                  "more-str": "Show more",
                                  text: _vm.settlementNote(2),
                                  "less-str": "Show less",
                                  "max-chars": 200
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ]
            )
          ]
        ),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-12 flex justify-content-md-end" }, [
          _c(
            "span",
            { staticClass: "sett-ammount-desc flex align-items-center" },
            [_vm._v("Approved amount: ")]
          ),
          _vm._v(" "),
          !_vm.loader
            ? _c("span", { staticClass: "sett-amount-sum" }, [
                _vm._v(" $" + _vm._s(_vm.claim.settlement_amount) + " ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.loader
            ? _c("div", { staticClass: "lds-ellipsis" }, [
                _c("div"),
                _vm._v(" "),
                _c("div"),
                _vm._v(" "),
                _c("div")
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-12 flex justify-content-md-end" },
          [
            !_vm.manualOverride &&
            _vm.$_can("claims.settlement.override") &&
            !_vm.claim.settlement_email_sent
              ? _c("span", { on: { click: _vm.toggleMailSentOverrideModal } }, [
                  _c("i", { staticClass: "fa fa-envelope mail-envelope-icon" })
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("Tooltip", {
              attrs: { config: { placement: "left" } },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(ref) {
                    var isOpen = ref.isOpen
                    var open = ref.open
                    var close = ref.close
                    return _c(
                      "div",
                      { on: { mouseover: open, mouseleave: close } },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: {
                              "data-trigger": "",
                              disabled: !_vm.canSendEmail
                            },
                            on: { click: _vm.toggleSidebar }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                "\n              Email customer with offer\n            "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: isOpen && !_vm.canSendEmail,
                                expression: "isOpen && !canSendEmail"
                              }
                            ],
                            staticClass:
                              "p-2 w-48 text-sm bg-white text-white shadow-lg z2 popup-border tooltip-overflow",
                            attrs: { "data-popper": "" }
                          },
                          [
                            _c("div", { attrs: { "x-arrow": "" } }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex flex-column align-items-center justify-content-center"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "text-dark popup-text" },
                                  [
                                    _vm._v(
                                      "\n                Cannot send the offer to customer\n                "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                until settlement amount was approved.\n              "
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  }
                }
              ])
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.claim.settlement_email_sent
          ? _c(
              "div",
              { staticClass: "col-md-12 mt-2 flex justify-content-md-end" },
              [
                _vm.claim.settlement_customer_approved === 1
                  ? _c("div", { staticClass: "flex flex-column" }, [
                      _c("span", { staticClass: "accepted" }, [
                        _vm._v(
                          "Customer accepted settlement amount of $" +
                            _vm._s(_vm.claim.settlement_amount_accepted) +
                            "."
                        )
                      ]),
                      _vm._v(" "),
                      _vm.claim.settlement_note
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "see-note flex justify-content-end pointer",
                              attrs: {
                                "data-toggle": "modal",
                                "data-target": "#noteModal"
                              }
                            },
                            [_vm._v("Show note")]
                          )
                        : _vm._e()
                    ])
                  : _vm.claim.settlement_customer_approved === 0
                    ? _c("div", { staticClass: "flex flex-column" }, [
                        _c("span", { staticClass: "declined" }, [
                          _vm._v(
                            "Customer declined settlement amount of $" +
                              _vm._s(_vm.claim.settlement_amount_accepted) +
                              "."
                          )
                        ]),
                        _vm._v(" "),
                        _vm.claim.settlement_note
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "see-note flex justify-content-end pointer",
                                attrs: {
                                  "data-toggle": "modal",
                                  "data-target": "#noteModal"
                                }
                              },
                              [_vm._v("Show note")]
                            )
                          : _vm._e()
                      ])
                    : _vm.claim.settlement_email_sent && _vm.manualOverride
                      ? _c("div", [
                          _c("span", [
                            _vm._v(
                              "Settlement offer sent manually to customer."
                            )
                          ])
                        ])
                      : _c("div", [
                          _c("span", [
                            _vm._v(
                              "Settlement offer of $" +
                                _vm._s(_vm.claim.settlement_amount_sent) +
                                " emailed to customer."
                            )
                          ])
                        ])
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showEmailModal
          ? _c(
              "div",
              { staticClass: "l-modal-mask" },
              [
                _c("send-claim-email", {
                  staticClass: "sidebar-right",
                  attrs: { job: _vm.claim.job, "type-id": 3 },
                  on: {
                    cancel: function($event) {
                      _vm.toggleSidebar()
                    },
                    update: function($event) {
                      _vm.$emit("update")
                    }
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "noteModal",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "noteModalLongTitle",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog", attrs: { role: "document" } },
            [
              _c("div", { staticClass: "modal-content" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.claim.settlement_note) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _vm._m(2)
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.officeDeclineModal
        ? _c("decline-settlement-amount", {
            attrs: {
              "settlement-amount": _vm.officeSettlementAmount,
              errors: _vm.errors
            },
            on: {
              close: _vm.toggleOfficeDeclineModal,
              update: function($event) {
                _vm.updateSettlementAmount(_vm.officeSettlementAmount, 4)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.subcoDeclineModal
        ? _c("decline-settlement-amount", {
            attrs: {
              "settlement-amount": _vm.subcoSettlementAmount,
              errors: _vm.errors
            },
            on: {
              close: _vm.toggleSubcoDeclineModal,
              update: function($event) {
                _vm.updateSettlementAmount(_vm.subcoSettlementAmount, 4)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.settlementOverride
        ? _c(
            "modal",
            {
              attrs: { size: "modal-small", "close-strict": true },
              on: {
                close: function($event) {
                  _vm.settlementOverride = false
                }
              }
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-10" })
                ])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c("div", { staticClass: "row text-center mt-3 p-4" }, [
                  _c("h4", [
                    _vm._v(
                      "This action will mark that the settlement email was sent to the customer. Please confirm to proceed."
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c("div", { staticClass: "row mb-2 mt-4" }, [
                  _c("div", { staticClass: "col text-center" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.settlementOverride = false
                          }
                        }
                      },
                      [_vm._v("\n            Cancel\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary ld-ext-right",
                        class: _vm.loadingButton ? "running" : "",
                        attrs: { type: "button", disabled: _vm.buttonDisabled },
                        on: { click: _vm.overrideSettlement }
                      },
                      [
                        _vm._v("\n            Yes, confirm\n            "),
                        _c("div", { staticClass: "ld ld-ball ld-flip" })
                      ]
                    )
                  ])
                ])
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("hr", { staticClass: "line" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h5",
        { staticClass: "modal-title", attrs: { id: "exampleModalLongTitle" } },
        [_vm._v("Customer note")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary",
          attrs: { type: "button", "data-dismiss": "modal" }
        },
        [_vm._v("Close")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d607a756", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d607a756","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/claims/ClaimSettlementAmount.vue
// module id = null
// module chunks = 